import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';
import CoreEvents from '../../core/events/CoreEvents';
import ChangeOrders from '../../core/events/ChangeOrders';
import ComponentEvents from '../../core/events/ComponentEvents';
import ButtonMediator from './ButtonMediator';
import StoriesDisplay from '../storiesDisplay/StoriesDisplay';
import {TweenMax} from 'gsap';
const _dispatcher = CoreMessageDispatcher.instance();
const Swiper = require('swiper').default;
const SizesUtils = require('../../../../viscomjs/utils/SizesUtils');

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr.swiperEl = mdr.el.querySelector('.swiper-container-textblock');

    mdr._update(true);
    _addCoreListeners(mdr, true);
    mdr.view.addListener('startTransition', mdr._onStartTransition);
    mdr.view.addListener('endTransition', mdr._onEndTransition);
    mdr.viewInitiated = true;
    // mdr.view.addListener('cuePoint', this._onCuePointTransition);
    mdr.closeMediator.start();
    mdr.knowMoreMediator.start();

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    if (mdr._tmo) {
        clearTimeout(mdr._tmo);
        mdr._tmo = null;
    }

    mdr.closeMediator.stop();
    mdr.knowMoreMediator.stop();

    _addCoreListeners(mdr, false);
    mdr.view.removeAllListeners('startTransition');
    mdr.view.removeAllListeners('endTransition');
    mdr.viewInitiated = false;
    // mdr.view.removeAllListeners('cuePoint');
    mdr.view.destroy();

    mdr.started = false;
    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    const isVisible = mdr.model.currentEventId === mdr.eventId && (mdr.model.currentCoverOpened || mdr.model.currentEventOpened);
    const isVisibleChanged = mdr.state.isVisible !== isVisible;
    const isOn = isVisible && mdr.model.currentEventOpened;
    const isOnChanged = mdr.state.isOn !== isOn;
    const isExpanded = mdr.state.isOn && mdr.model.currentEventExpanded;
    const isExpandedChanged = mdr.state.isExpanded !== isExpanded;

    mdr.state.isOn = isOn;
    mdr.state.isExpanded = isExpanded;
    mdr.state.isVisible = isVisible;

    const sceneDecorState = !isVisible ? 'hidden' : mdr.model.currentEventOpened ? 'opened' : mdr.model.currentCoverOpened ? 'visible' : 'hidden';
    const sceneDecorStateChanged = mdr.state.sceneDecorState !== sceneDecorState;
    mdr.state.state = sceneDecorState;

    // View: can be substituted by JS-animation
    mdr.el.dataset.isOn = mdr.state.isOn;
    mdr.el.dataset.isExpanded = mdr.state.isExpanded;
    mdr.el.dataset.isVisible = mdr.state.isVisible;

    if (isVisibleChanged && isVisible) {
        if (!isOn && !isExpanded) {
            if (mdr._tmoAutoplay) {
                clearTimeout(mdr._tmoAutoplay);
                mdr._tmoAutoplay = null;
            }
            mdr._tmoAutoplay = setTimeout(
                //
                () => {
                    _dispatcher.emit(ChangeOrders.AUTPLAY_TO_STATE, mdr.eventId);

                    if (mdr._tmoAutoplay) {
                        clearTimeout(mdr._tmoAutoplay);
                        mdr._tmoAutoplay = null;
                    }
                },
                mdr.params.autoplayDelay
            );
        }
    }

    if (isOn || isExpanded || !isVisible) {
        if (mdr._tmoAutoplay) {
            clearTimeout(mdr._tmoAutoplay);
            mdr._tmoAutoplay = null;
        }
    }

    if (isOn && isExpanded) {
        const w = SizesUtils.winWidth();
        const h = SizesUtils.winHeight();

        // eslint-disable-next-line no-empty
        if (h > w || (w <= 425 || h <= 425) || (w > 425 && w <= 768 && h > 425 && h < w)) {
        } else {
            mdr.swiper = new Swiper(mdr.swiperEl, {
                direction: 'vertical',
                slidesPerView: 'auto',
                freeMode: true,
                wrapperClass: 'swiper-wrapper-textblock',
                slideClass: 'swiper-slide-textblock',
                scrollbar: {
                    el: '.swiper-scrollbar-textblock',
                    draggable: true,
                    hide: true
                },
                mousewheel: true
            });
        }
    }

    if (!(isOn && isExpanded) && mdr.swiper) {
        mdr.swiper.destroy();
        mdr.swiper = null;
    }

    if (isOnChanged) {
        if (mdr._tmo) {
            clearTimeout(mdr._tmo);
            mdr._tmo = null;
        }
        mdr._tmo = setTimeout(
            () => {
                if (mdr.elsToMirrorState) {
                    mdr.elsToMirrorState.forEach(el => {
                        el.dataset.eventIsOn = mdr.state.isOn;
                    });
                }
            },
            mdr.state.isOn ? 0 : 1000
        );
    }

    if (isExpandedChanged) {
        const toggleBlock = (textBlockBg, textBlockSize, textBlockTarget, expand) => {
            if (!textBlockBg) return;

            const textBlockBgBounding = textBlockSize.getBoundingClientRect();
            const textBlockTargetBounding = textBlockTarget.getBoundingClientRect();

            // For mobile version
            if (textBlockBgBounding.width <= 0 || textBlockBgBounding.height <= 0) return;

            const xRatio = expand ? textBlockTargetBounding.width / textBlockBgBounding.width : 1;
            const yRatio = expand ? textBlockTargetBounding.height / textBlockBgBounding.height : 1;

            textBlockBg.style.transitionDuration = '0s';
            textBlockBg.style.transitionDelay = '0s';
            TweenMax.to(textBlockBg, expand ? 0.45 : 0.35, {
                scaleX: xRatio,
                scaleY: yRatio,
                transformOrigin: '100% 100%',
                onComplete: () => {
                    textBlockBg.style.transitionDuration = '';
                    textBlockBg.style.transitionDelay = '';

                    if (!expand) {
                        textBlockBg.style.transform = '';
                        textBlockBg.style.transformOrigin = '';
                    }
                }
            });
        };

        if (mdr.state.isExpanded) {
            mdr.closeMediator.setEvent(ChangeOrders.COLLAPSE_CURRENT_EVENT);
            mdr.knowModeBtn.classList.add('active');
        } else {
            mdr.closeMediator.setEvent(ChangeOrders.CLOSE_CURRENT_EVENT);
            mdr.knowModeBtn.classList.remove('active');
        }
        toggleBlock(mdr.textBlockBg, mdr.textBlockSize, mdr.textBlockTarget, mdr.state.isExpanded);
    }

    // TODO: move to Story Mediator
    if (sceneDecorStateChanged) {
        if (mdr.state.state !== 'hidden') {
            mdr.view.init(mdr.viewRoot, mdr.viewCenterDefEl);
            if (!mdr.viewInitiated) {
                mdr.view.addListener('startTransition', mdr._onStartTransition);
                mdr.view.addListener('endTransition', mdr._onEndTransition);
            }
            mdr.viewInitiated = true;
        }
        mdr.view.start();
        mdr.view.setState(mdr.state.state);
    }

    return mdr;
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(CoreEvents.MODEL_STATE_CHANGED, mdr._update);
        _dispatcher.on(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr._update);
        return;
    }

    _dispatcher.off(CoreEvents.MODEL_STATE_CHANGED, mdr._update);
    _dispatcher.off(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr._update);
};

//

//
// Internal methods
//
const _onStartTransition = () => {
    _dispatcher.emit(ComponentEvents.TRANSITION_STARTED);
};

const _onEndTransition = mdr => {
    if (mdr.state.state === 'hidden') {
        mdr.view.destroy();
        mdr.viewInitiated = false;
    }
    _dispatcher.emit(ComponentEvents.TRANSITION_ENDED);
};

//
// Constructor
//
const EventDisplayMediator = (el, centerEl, model, elsToMirrorState) => {
    const knowModeBtn = el.querySelector('.ui-know-more');
    const eventId = el.dataset.eventId;
    const mdr = {
        el: el,
        viewCenterDefEl: centerEl,
        view: StoriesDisplay({id: eventId}),
        viewRoot: el.querySelector('.illustration--story'),
        textBlockBg: el.querySelector('.event__text__bg'),
        textBlockSize: el.querySelector('.event__text'),
        textBlockTarget: el.querySelector('.event__complete-text'),
        model: model,
        eventId: eventId,
        knowModeBtn: knowModeBtn,
        closeMediator: ButtonMediator(el.querySelector('.ui-close'), ChangeOrders.CLOSE_CURRENT_EVENT),
        knowMoreMediator: ButtonMediator(knowModeBtn, ChangeOrders.EXPAND_CURRENT_EVENT),
        elsToMirrorState: elsToMirrorState instanceof Array ? elsToMirrorState : null,
        state: {
            isOn: false,
            isExpanded: false,
            isVisible: false
        },
        swiper: null,
        swiperEl: null,
        params: {
            autoplayDelay: 3000
        }
    };

    mdr.start = () => {
        return _start(mdr);
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    mdr._onStartTransition = () => {
        return _onStartTransition(mdr);
    };

    mdr._onEndTransition = () => {
        return _onEndTransition(mdr);
    };

    return mdr;
};

export {EventDisplayMediator};
export default EventDisplayMediator;
